<template>
  <div class="home" style="overflow: hidden;" v-if="userInformations && company">
  
      <b-row class="m-0 justify-content-center w-100 h-100 bg-white" >
        <div style="width: 1700px; max-width: 100%">
          <div>
            <b-row class="d-none d-lg-flex justify-content-between px-5 shadow bg-white" style="position: fixed; top: 0; left: 0; right: 0; z-index: 100" v-if="orders">
              <h1 style="font-size: 70px; width: 300px">{{ timestamp }}</h1>
              <div v-if="orders.filter(el => el.status == 'bestellt')">
                <b-row class="m-0 d-none d-md-flex" v-if="orders.filter(el => el.status == 'bestellt' && el.customer_verified).length > 0">
                  <h3 class="m-0 text-danger center "  >Offene Bestellungen: {{ orders.filter(el => el.status == 'bestellt' && el.customer_verified).length }}</h3>
                  <b-icon  icon="circle-fill" class="mt-3" style="margin-left: 150px" variant="danger" animation="throb" font-scale="4"></b-icon>
                </b-row>
            </div>
            <b-form-group class="mt-1" label="Aktuelle Lieferzeit in Minuten" v-if="company.delivery">
              <b-row>
                <b-form-input
                  style="width: 150px"
                  v-model="company.actual_delivery_time"
                  type="number"
                  step="1"
                  placeholder="Zeit in Minuten eingeben..."
                  required
                ></b-form-input>
                <b-button class="ml-2" @click="updateCompany()">speichern <b-spinner v-if="updating" small label="Spinning"></b-spinner></b-button>
              </b-row>
                
              </b-form-group>
              <b-button class="mt-4 linear-info text-white border" size="sm" style="height: 40px; font-size: 15px" @click="$router.push('/dashboard').catch(err => {})"> <font-awesome-icon style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/></b-button>
            </b-row>
            <b-row class="d-lg-none justify-content-end px-5" style="position: fixed; top: 0; left: 0; right: 0; z-index: 100" v-if="orders">
              <b-button class="mt-4 linear-info text-white border" size="sm" style="height: 40px; font-size: 15px" @click="$router.push('/dashboard').catch(err => {})"> <font-awesome-icon style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/></b-button>
            </b-row>
            <div class="d-none d-lg-flex" style="margin-bottom: 100px">

              </div>
            <b-row class="m-0 justify-content-start" >
              
              <b-col cols="12" md="4" style="w-100" class="p-1" v-for="(slotplace) in slots" :key="slotplace.index">
                <div  class="showcase-invert bg-white shadow mb-2 mt-4" style="width: 100%" v-if="company">

                  <div class="showcase-header text-white" :class="getHeaderVariant(slotplace)" style="position: relative; cursor: pointer">
                    <h1 class="text-center m-0">{{slotplace.time}}</h1>
                  </div>
                  <div v-if="company.orderSlots">
                    <div v-if="company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString) && checkOpeningTimes(slotplace.time)">
                      <div  v-for="(slot) in company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString).orders" :key="slot.index">
                        
                        <div class="p-3 card mb-3" v-if="findOrder(slot._id)" :class="findOrder(slot._id).status == 'storniert' ? 'bg-danger' : 'bg-light'">
                          <h3 class="text-center text-white" v-if="findOrder(slot._id).status == 'storniert'"> STORNIERT </h3>
                          <h3 class="text-center text-info pb-2" v-if="findOrder(slot._id).addressData"> LIEFERUNG </h3>
                          <h3 class="text-center text-info pb-2" v-else> ABHOLUNG </h3>
                          <b-row class="m-0 justify-content-between">
                            <h5 class="m-0">Telefon: </h5>
                            <h5 class="m-0">{{findOrder(slot._id).customer_phone}}</h5>
                          </b-row>
                          <b-row class="m-0 justify-content-between">
                            <h5 class="m-0">Besteller: </h5>
                            <h5 class="m-0">{{findOrder(slot._id).customer_firstname}} {{findOrder(slot._id).customer_lastname}}</h5>
                          </b-row>
                          <b-row class="m-0 justify-content-between" v-if="findOrder(slot._id).addressData">
                            <h5 class="m-0 mb-2">Lieferzeit: </h5>
                            <h5 class="m-0 mb-2">{{findOrder(slot._id).delivery_time | moment('DD.MM.YYYY HH:mm')}}</h5>
                          </b-row>
                          <div class="m-0 justify-content-between" v-if="findOrder(slot._id).addressData">
                            <h5 class="m-0 mb-2">Lieferadresse: </h5>
                            <h5 class="m-0 mb-2">{{findOrder(slot._id).addressData.locality}}</h5>
                          </div>
                          
                          <b-button size="sm" class="mt-2" v-b-toggle="'order-collapse-'+findOrder(slot._id)._id"> Bestellung anzeigen </b-button>

                          <b-collapse :id="'order-collapse-'+findOrder(slot._id)._id" >
                            <div class="mt-3">
                              <hr>
                              <div class="my-2" v-for="item in findOrder(slot._id).items" :key="item.index">
                                <b-row class="m-0 justify-content-between" >
                                  <b-row class="m-0">
                                    <h5 class="m-0" v-if="item._id.number">Nr. {{ item._id.number }} -</h5>
                                    <h5 class="m-0 ml-2">{{ item._id.title }}</h5>
                                  </b-row>
                                  <h5 class="m-0">x {{ item.amount }}</h5>
                                </b-row>
                                <b-row class="m-0 justify-content-between" v-if="item.note">
                                  <p class="m-0">Hinweis: {{ item.note }}</p>
                                </b-row>

                                <div v-if="item.variants">
                                  <div v-if="item.variants.length > 0">
                                    <u><p class="m-0 mt-2">Variante(n):</p></u>
                                    <b-row class="m-0 mt-1 justify-content-between" v-if="item.variants">
                                      <div v-for="variant in item.variants" class="w-100" :key="variant.index">
                                        <h5 v-if="variant.choosen" class="m-0">{{ variant.choosen.title }}</h5>
                                      </div>
                                    </b-row>
                                  </div>
                                </div>

                                <div v-if="item.extras">
                                  <div v-if="item.extras.filter(extra => extra.choosen).length > 0">
                                    <u><p class="m-0 mt-2">Beilagen / Extras:</p></u>
                                    <b-row class="m-0  justify-content-between" v-if="item.extras">
                                      <div v-for="extra in item.extras" class="w-100" :key="extra.index">
                                        <h5 v-if="extra.choosen" class="m-0">{{ extra.title }}</h5>
                                      </div>
                                    </b-row>
                                  </div>
                                </div>
                                
                                <hr>
                              </div>
                              
                            </div>
                            <div v-if="findOrder(slot._id)">
                              <b-row class="m-0 mt-3 justify-content-between" v-if="findOrder(slot._id).delivery_fee">
                                <h5 class="m-0">Liefergebühr:</h5>
                                <h5 class="m-0">{{findOrder(slot._id).delivery_fee.toFixed(2)}}€</h5>
                              </b-row>
                            </div>
                            
                            <b-row class="m-0 mt-3 justify-content-between">
                              <h4 class="m-0">Rechnungsbetrag:</h4>
                              <h4 class="m-0">{{getTotalPrice(findOrder(slot._id))}}€</h4>
                            </b-row>
                          </b-collapse>
                        <b-row class="m-0 mt-4 justify-content-between">
                          <b-button block variant="warning" v-if="findOrder(slot._id).status == 'bestellt'" @click="openConfirmModal(findOrder(slot._id), 'bestätigt')">Bestellung bestätigen</b-button>
                          <b-button block size="" class="mt-3" variant="danger" v-if="findOrder(slot._id).status == 'bestellt'" @click="openConfirmModal(findOrder(slot._id), 'storniert')">Bestellung stornieren</b-button>
                          <b-button block variant="info" v-if="findOrder(slot._id).status == 'bestätigt'" @click="openConfirmModal(findOrder(slot._id), 'bereit')">Bestellung ist abholbereit</b-button>
                          <b-button block variant="success" v-if="findOrder(slot._id).status == 'bereit'" @click="openConfirmModal(findOrder(slot._id), 'abgeholt')">Bestellung wurde abgeholt</b-button>
                          <b-button block variant="success" disabled v-if="findOrder(slot._id).status == 'abgeholt'" >Bestellung ist abgeschlossen!</b-button>
                        </b-row>
                      </div>
                      <div v-if="slot.blocked_manual" class="p-3 card mb-3 bg-light">
                        <b-row class="m-0 justify-content-center">
                          <b-button variant="success" @click="blockOrderSlot(slotplace.time, true)">Bestellung freigeben</b-button>
                        </b-row>
                      </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="company.orderSlots">
                    <div v-if="company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString)">
                      <div v-if="company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString).orders.length < company.amount_slots">
                        <div class="p-3 card bg-light mb-3" v-for="(a) in company.amount_slots - company.orderSlots.find(slot => slot.time == slotplace.time && slot.date == timeString).orders.length" :key="a.index">
                          <b-row class="m-0 justify-content-center">
                            <b-button variant="danger" @click="blockOrderSlot(slotplace.time, false)">Bestellung reservieren</b-button>
                          </b-row>
                        </div>
                      </div>
                    </div>
                    <div v-else>
                      <div class="p-3 card bg-light mb-3" v-for="(a) in company.amount_slots" :key="a.index">
                        <b-row class="m-0 justify-content-center">
                          <b-button variant="danger" @click="blockOrderSlot(slotplace.time, false)">Bestellung reservieren</b-button>
                        </b-row>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div v-for="(a) in company.amount_slots" :key="a.index">
                      <b-row class="m-0 justify-content-center">
                        <b-button variant="danger" @click="blockOrderSlot(slotplace.time, false)">Bestellung reservieren</b-button>
                      </b-row>
                      <hr>
                    </div>
                  </div>
                  
                </div>
              </b-col>

            </b-row>
           
            
          </div>
        </div>
      </b-row>

      <hr class="mx-4" style="border: 3px solid grey">

      <div v-for="nextOrderSlot in nextOrderSlots" :key="nextOrderSlot.index">
        <b-row class="m-0 justify-content-center" >
          <h1 class="text-center">{{nextOrderSlot[0].date | moment('DD.MM.YYYY') }}</h1>
        </b-row>

        <b-row class="m-0 justify-content-start" >
          <b-col cols="12" md="4" style="w-100" class="p-1" v-for="(slotplace) in nextOrderSlot" :key="slotplace.index" >
          <div  class="showcase-invert bg-white shadow mb-2 mt-4" style="width: 100%" >
            <div class="showcase-header text-white" :class="getHeaderVariantNext(slotplace)" style="position: relative; cursor: pointer">
              <h1 class="text-center m-0">{{slotplace.time}}</h1>
            </div>
            <div v-if="company.orderSlots">
              <div>
                <div class="" v-for="(slot) in slotplace.orders.filter(el => findOrder(el._id).status == 'bestellt')" :key="slot.index">
                  <div class="p-3 card mb-3" v-if="findOrder(slot._id)" :class="findOrder(slot._id).status == 'storniert' ? 'bg-danger' : 'bg-light'">
                     <h3 class="text-center text-white" v-if="findOrder(slot._id).status == 'storniert'"> STORNIERT </h3>
                    <b-row class="m-0 justify-content-between">
                      <h5 class="m-0">Telefon: </h5>
                      <h5 class="m-0">{{findOrder(slot._id).customer_phone}}</h5>
                    </b-row>
                    <b-row class="m-0 justify-content-between">
                      <h5 class="m-0">Besteller: </h5>
                      <h5 class="m-0">{{findOrder(slot._id).customer_firstname}} {{findOrder(slot._id).customer_lastname}}</h5>
                    </b-row>

                    <b-button size="sm" class="mt-2" v-b-toggle="'order-collapse-'+findOrder(slot._id)._id"> Bestellung anzeigen </b-button>

                    <b-collapse :id="'order-collapse-'+findOrder(slot._id)._id" >
                      <div class="mt-3">
                        <hr>
                        <div class="mb-2" v-for="item in findOrder(slot._id).items" :key="item.index">
                          <b-row class="m-0 justify-content-between" >
                            <b-row class="m-0">
                              <h5 class="m-0" v-if="item._id.number">Nr. {{ item._id.number }} -</h5>
                              <h5 class="m-0 ml-2">{{ item._id.title }}</h5>
                            </b-row>
                            
                            <h5 class="m-0">x {{ item.amount }}</h5>
                          </b-row>
                          <b-row class="m-0 justify-content-between" v-if="item.note">
                            <p class="m-0">Hinweis: {{ item.note }}</p>
                          </b-row>
                          <div v-if="item.variants">
                            <div v-if="item.variants.length > 0">
                              <u><p class="m-0 mt-2">Variante(n):</p></u>
                              <b-row class="m-0 mt-1 justify-content-between" v-if="item.variants">
                                <div v-for="variant in item.variants" class="w-100" :key="variant.index">
                                  <h5 v-if="variant.choosen" class="m-0">{{ variant.choosen.title }}</h5>
                                </div>
                              </b-row>
                            </div>
                          </div>

                          <div v-if="item.extras">
                            <div v-if="item.extras.filter(extra => extra.choosen).length > 0">
                              <u><p class="m-0 mt-2">Beilagen / Extras:</p></u>
                              <b-row class="m-0  justify-content-between" v-if="item.extras">
                                <div v-for="extra in item.extras" class="w-100" :key="extra.index">
                                  <h5 v-if="extra.choosen" class="m-0">{{ extra.title }}</h5>
                                </div>
                              </b-row>
                            </div>
                          </div>
                          <hr>
                        </div>
                      </div>
                      <b-row class="m-0 mt-3 justify-content-between">
                        <h4 class="m-0">Rechnungsbetrag:</h4>
                        <h4 class="m-0">{{getTotalPrice(findOrder(slot._id))}}</h4>
                      </b-row>
                    </b-collapse>
                  <b-row class="m-0 mt-4 justify-content-between">
                    <b-button block variant="warning" v-if="findOrder(slot._id).status == 'bestellt'" @click="openConfirmModal(findOrder(slot._id), 'bestätigt')">Bestellung bestätigen</b-button>
                    <b-button block variant="info" v-if="findOrder(slot._id).status == 'bestätigt'" @click="openConfirmModal(findOrder(slot._id), 'bereit')">Bestellung ist abholbereit</b-button>
                    <b-button block variant="success" v-if="findOrder(slot._id).status == 'bereit'" @click="openConfirmModal(findOrder(slot._id), 'abgeholt')">Bestellung wurde abgeholt</b-button>
                    <b-button block variant="success" disabled v-if="findOrder(slot._id).status == 'abgeholt'" >Bestellung ist abgeschlossen!</b-button>
                  </b-row>
                </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        </b-row>
        <hr class="mx-4" style="border: 3px solid grey">
      </div>
      

     <b-modal id="infoModal" centered v-model="confirmModal" hide-footer hide-header v-if="updateBuffer.status">
      <div class="bg-white" style="border-radius: 10px; transition: all .5s;">
        <b-row class="m-0 p-3 justify-content-between" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
          <h4 class="ml-2 text-center text-dark">Bestätigung erforderlich</h4>
          <font-awesome-icon @click="confirmModal = false" style="font-size: 30px; cursor: pointer" :icon="['fas', 'times']"/>
        </b-row>
        <div class="m-2">
          <div class="py-3">
           <h5 class="text-center">Soll der Status der Bestellung geändert werden zu: </h5>
           <h3 class="text-center my-3">{{updateBuffer.status.toUpperCase()}}</h3> 

           <p class="text-center text-danger">Dies kann nicht rückgängig gemacht werden!</p>
           <p class="text-center text-danger" v-if="updateBuffer.status == 'bestätigt'">Der Kunde wird per SMS informiert!</p>
          </div>
          <b-row class="m-0 p-3 justify-content-between">
            <b-button variant="success" @click="updateOrder(updateBuffer.order, updateBuffer.status)">Status setzen</b-button>
            <b-button variant="danger">abbrechen</b-button>
          </b-row>
        </div>
       
      </div>
    </b-modal>
    
  </div>
</template>

<script>
import coreData from '@/mixins/coreDataMixin'
import axiosAuth from '@/shared/configs/axios-auth'

export default {
  name: 'Kiosk',
  mixins: [coreData],
  components: {


  }, 
  data: () => {
    return {
      updateBuffer: {},
      confirmModal: false,
      blink: false,
      orderBuffer: [],
      error: null,
      actualTime: null,
      sortDesc: false, 
      sortBy: 'delivery_time',
      interval: null,
      intervalPeriodic: null,
      timestamp: "",
      loadingWizard: false,
         errorMsg: null,
         count: 0,
      imageData: "",
      file1: null,
      countriesSelect: [{ text: 'auswählen...', value: null }, 'Deutschland', 'Österreich', 'Schweiz'],
      form: {},
      restaurant: {
        adress: {},
        contact: {}
      },
      fields: [
        { key: 'created', label: 'Bestellzeit' },
        { key: 'delivery_time', label: 'Abhol-/Lieferzeit'},
        { key: 'customer_firstname', label: 'Kunde' },
        { key: 'price', label: 'Preis' },
        // { key: 'payment_method', label: 'Zahlungsmethode' },
        { key: 'ordernumber', label: 'Bestellnummer' },
        { key: 'status', label: 'Status' },
        { key: 'customer_verified', label: 'Bestätigt' },
        // { key: 'action', label: 'Aktionen' },
      ],
      plus: null
    }
  },
  computed: {
    nextOrderSlots(){
      var array = []

      if(this.company){
        const filteredOrderSlots = this.company.orderSlots.filter(slot => slot.date != this.timeString && new Date(slot.date) > new Date(this.timeString))
        array = filteredOrderSlots.filter(el => el.orders.find(order => this.findOrder(order._id).status == 'bestellt'))

        array.sort(function(a, b) {
          var nameA = new Date(a.date);
          var nameB = new Date(b.date);
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          return 0;
        });

        var groupBy = function(xs, key) {
          return xs.reduce(function(rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
          }, {});
        };
      }
      if(array.length > 0){
        return groupBy(array, 'date')
      }else{
        return array
      }
      
    },
    timeString(){
      var newDate = new Date()
      return newDate.getFullYear()+ '-' + ("0" + (newDate.getMonth()+1)).slice(-2) + '-' + ("0" + newDate.getDate()).slice(-2)
    },

    nextTimes(){

      var times = {
        time1: {
          date: null,
          time: null
        }
      }
      var today = new Date()

      if(this.actualTime){
        today = this.actualTime;
      }
      today.setMinutes(today.getMinutes() - 30);
      today.setMinutes(today.getMinutes());
      if(this.selectedDate){
        today = new Date(this.selectedDate+'T' + ("0" + today.getHours()).slice(-2) + ':' + ("0" + (today.getMinutes())).slice(-2) +':00')
      }
            
      var m = (((today.getMinutes() + 7.5)/15 | 0) * 15) % 60;
      var h = ((((today.getMinutes()/105) + .5) | 0) + today.getHours()) % 24;
      
      var timestring =  today.getFullYear()+ '-' + ("0" + (today.getMonth()+1)).slice(-2) + '-' + ("0" + today.getDate()).slice(-2) + 'T' + ("0" + h).slice(-2) + ':' + ("0" + m).slice(-2) +':00'
      var rounded = new Date(timestring);

      var m1 = (parseInt((rounded.getMinutes() + 7.5)/15) * 15) % 60;

      times.time1.time = ("0" + (rounded.getHours())).slice(-2) +':'+ ("0" + m1).slice(-2)
      times.time1.date = rounded

      return times
    },
  },
  mounted(){
    this.refreshData();

    try {
      this.intervalPeriodic = setInterval( this.refreshPeriodic, 30000);
    } catch (error) {
      console.log(error)
    }

    if(this.company){
      this.$store.dispatch('checkSlots', {company: this.company._id, date: this.timeString})
    }
    
    this.$store.dispatch('getOrders')
    this.getNow()
    this.interval = setInterval(this.getNow, 1000);
  },
  beforeDestroy(){
    clearInterval(this.interval)
    clearInterval(this.intervalPeriodic)
  },
  watch:{
    confirmModal(){
      if(!this.confirmModal){
        this.updateBuffer = {}
      }
    },
    company(){
      if(this.company){
        this.restaurant = this.company
        this.$store.dispatch('checkSlots', {company: this.company._id, date: this.timeString})
      }
    },
    orders(){
      if(this.orderBuffer.length > 0){
        this.orders.forEach(element => {
          if(!this.orderBuffer.find(order => order._id == element._id) && element.customer_verified){
            this.makeToast()
          }
        })
        this.orderBuffer = []
        this.orders.forEach(element => {
          if(element.customer_verified){
            this.orderBuffer.push({_id: element._id})
          }
        });
      }else{
        this.orders.forEach(element => {
          if(element.customer_verified){
            this.orderBuffer.push({_id: element._id})
          }
        });        
      }
    }
  },
  methods: {
    makeToast(append = false) {
      this.toastCount++
      this.$bvToast.toast(`Eine neue Bestellung ist eingetroffen!`, {
        title: 'Neue Bestellung!',
        autoHideDelay: 5000,
        appendToast: append
      })
      this.playSound()
    },
    getHeaderVariant(slotplace){
      if(!this.orders) return
      var test = this.orders.filter(slot => slot.time == slotplace.time && slot.date == this.timeString && slot.customer_verified)
      var variant = 'linear-primary '
      if(test.length > 0){
        if(test.find(el => el.status == 'bestellt') ) {
          if(this.blink){
            variant = 'linear-danger pulse'
          }else{
            variant = 'linear-warning pulse'
          }
          

        }
      }
      return variant
    },
    getHeaderVariantNext(slotplace){
      var variant = 'linear-primary '
      if(slotplace.orders.length > 0){
        if(slotplace.orders.find(el => this.findOrder(el._id).status == 'bestellt') ) {
          if(this.blink){
            variant = 'linear-danger pulse'
          }else{
            variant = 'linear-warning pulse'
          }
    
        }
      }
      return variant
    },
    refreshPeriodic(){
      this.$store.dispatch('getOrders')
      this.$store.dispatch('checkSlots', {company: this.company._id, date: this.timeString})
      this.$store.dispatch('getCompany')
    },
    getDateFromTime(time){
      var date = new Date(this.timeString+'T'+time)
      return date
    },
    blockOrderSlot(time, unblock){
      var date = this.timeString
      var payload = {
        data: {
          date: date,
          time: time,
        }
      }
      if(!unblock){
        this.$store.dispatch('blockOrderSlot', payload)
      }else{
        payload = {
          data: {
            date: date,
            time: time,
            unblock: true,
          }
        }
        this.$store.dispatch('blockOrderSlot', payload)
      }
    },

    openConfirmModal(order, status){
      this.updateBuffer = {order: order, status: status}
      this.confirmModal = true
    },

    updateOrder(order, status){
      if(!order.customer_verified) return
      const payload = {
        _id: order._id,
        data: {
          status: status
        }
      }
      this.$store.dispatch('updateOrder', payload)
      this.confirmModal = true
      this.updateBuffer = {}
    },
    findOrder(id){
      var order = this.orders.find(orders => orders._id == id)
      if(order) return order
      return null
    },
    getNextTime(minutes){
      var date = new Date(this.nextTimes.time1.date.getTime() + minutes*60000);
      var payload = {
        date: date,
        time: ("0" + (date.getHours())).slice(-2)+':'+("0" + (date.getMinutes())).slice(-2)
      }
      return payload
    },
    getNextTime2(minutes, time){
      var today = new Date(this.timeString+'T'+time+':00')
      var date = new Date(today.getTime() + minutes*60000);
      var payload = {
        date: date,
        time: ("0" + (date.getHours())).slice(-2)+':'+("0" + (date.getMinutes())).slice(-2)
      }
      return payload
    },
    getNow: function() {
        const today = new Date();
        this.actualTime = new Date();
        const time = ("0" + today.getHours()).slice(-2) +':'+ ("0" + today.getMinutes()).slice(-2)+':'+ ("0" + today.getSeconds()).slice(-2)
        const dateTime = time;
        this.timestamp = dateTime;
        this.blink = !this.blink;
    },
    toggle () {
      this.$store.commit('showUi', !this.showUi)
      this.$store.commit('fullscreen', !this.fullscreen)

      // document.documentElement.requestFullscreen().catch((e) => this.error = e);
      // if(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullscreenElement || document.msFullscreenElement){
      //   document.exitFullscreen();
      // }

      // if (document.documentElement.webkitRequestFullscreen) {
      //   document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      // } else {
      //   if (document.documentElement.mozRequestFullScreen) {
      //     document.documentElement.mozRequestFullScreen();
      //   } else {
      //     if (document.documentElement.requestFullscreen) {
      //   document.documentElement.requestFullscreen();
      // }
      //   }
      // }
      //this.$refs['fullscreen'].toggle() // recommended
      // this.fullscreen = !this.fullscreen // deprecated
    },
    fullscreenChange (fullscreen) {
      this.fullscreen = fullscreen
    },
    getTotalMonth(){
      var total = 0.0
      if(!this.orders) return total
      this.orders.forEach(element => {
        element.items.forEach(item => {
          total += item.amount * item._id.price
        })
      });
      return total.toFixed(2) + '€'
    },
        onComplete: function(){
          try {
            axiosAuth.patch('/users/me', {initDone: true})
            .then(
                () => {
                  this.userInformations.initDone = true
                }
              )
            .catch(
                error => {
                  alert('NOPE. DOPE');
                    console.log(error.response)

                }
            ) 
            
          } catch (error) {
            console.log(error)
          }
           
        },
        setLoading: function(value) {
            this.loadingWizard = value
        },
        handleValidation: function(isValid, tabIndex){
           console.log('Tab: '+tabIndex+ ' valid: '+isValid)
        },
        handleErrorMessage: function(errorMsg){
          console.log(errorMsg)
          this.errorMsg = errorMsg
        },
        validateAsyncStep1:function() {
          return new Promise((resolve, reject) => {

              if(!this.userInformations.firstname || !this.userInformations.lastname || !this.userInformations.contact.phone || !this.userInformations.adress.street || !this.userInformations.adress.zipcode || !this.userInformations.adress.city || !this.userInformations.adress.country){
                reject('Es wurden nicht alle Felder ausgefüllt!')
              }else{
                const payload = {
  
                  firstname: this.userInformations.firstname,
                  lastname: this.userInformations.lastname,
                  adress: {
                    street: this.userInformations.adress.street,
                    zipcode: this.userInformations.adress.zipcode,
                    city: this.userInformations.adress.city,
                    country: this.userInformations.adress.country,
                  },
                  contact:{
                    email: this.userInformations.email,
                    phone: this.userInformations.contact.phone
                  } 
                }
                try {
                  axiosAuth.patch('/users/me', payload)
                  .then(
                      () => {
                          resolve(true)
                      }
                    )
                  .catch(
                      error => {
                          console.log(error.response)
                          reject(error.response.data)
                      }
                  ) 
                  
                } catch (error) {
                  reject(error)
                }
                
                
              }

          })
         },
        
        validateAsyncStep2:function() {
          return new Promise((resolve, reject) => {

              if(!this.restaurant.title || !this.restaurant.description || !this.restaurant.contact.phone || !this.restaurant.contact.email || !this.restaurant.adress.street || !this.restaurant.adress.zipcode || !this.restaurant.adress.city || !this.restaurant.adress.country){
                reject('Es wurden nicht alle Felder ausgefüllt!')
              }else{
                if(!this.company){
                  axiosAuth.post('/companies', this.restaurant)
                    .then(
                        () => {
                            this.$store.dispatch('getCompany')
                            resolve(true)
                        }
                    )
                    .catch(
                    error => {
                      
                        console.log(error.response)
                        reject(error.response.data)
                    }
                  )
                }else{
                  
                  var payload = {
                    title: this.company.title,
                    description: this.company.description,
                    adress: {
                        city: this.company.adress.city,
                        street: this.company.adress.street,
                        zipcode: this.company.adress.zipcode,
                        country: this.company.adress.country
                    },
                    contact: {
                        email: this.company.contact.email,
                        phone: this.company.contact.phone
                    },
                  }

                  axiosAuth.patch('/companies/'+ this.company._id, payload)
                    .then(
                        () => {
                          this.$store.dispatch('getCompany')
                          resolve(true)
                        }
                      )
                    .catch(
                        error => {
                            console.log(error.response)
                        reject(error.response.data)
                        }
                    ) 
                }
                
              }

          })
         },

         validateAsyncStep3:function() {
          return new Promise((resolve, reject) => {

              if(!this.file1 && !this.company.img){
                reject('Es wurde kein Logo hochgeladen!')
              }else{
                
                if(this.imageData){
                  let formData = new FormData();

                    formData.append('company', this.company._id)
                    formData.append('image', this.file1);

                    axiosAuth.post('companies/upload', formData,)
                      .then(
                        () => {
                          this.$store.dispatch('getCompany')
                          resolve(true)
                        }
                      )
                    .catch(
                        error => {
                            console.log(error.response)
                        reject(error.response.data)
                        }
                    ) 
                }else{
                  resolve(true)
                }
                    

              }

          })
         },
  
    onSubmit(){

    },

    previewImage: function(event) {
        // Reference to the DOM input element
        var input = event.target;
        // Ensure that you have a file before attempting to read it
        if (input.files && input.files[0]) {
            // create a new FileReader to read this image and convert to base64 format
            var reader = new FileReader();
            // Define a callback function to run, when FileReader finishes its job
            reader.onload = (e) => {
                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                // Read image as base64 and set to imageData
                this.imageData = e.target.result;
            }
            // Start the reader job - read file as a data url (base64 format)
            reader.readAsDataURL(input.files[0]);
        }
    }
  }
}
</script>

<style lang="scss">

</style>